<div class="rich-perk-list">
  <div class="perk-vertical-group" *ngFor="let perkGroup of possiblePerks; let idx = index">
    <app-weapon-perk [perk]="perk" [itemHash]="item.definition.hash" *ngFor="let perk of perkGroup" [lowlightUnavailable]="displayAllPossiblePerks"></app-weapon-perk>
  </div>
</div>
